import { useRecoilValue } from 'recoil'
import themes from '../../assets/styles/themes'
import Footer from '../../components/layout/Footer/Footer'
import GradeCard from '../../components/layout/GradeCard/GradeCard'
import {  Container } from '../../components/layout/Grid/Grid'
import Header from '../../components/layout/Header/Header'
import Title from '../../components/Typography/Title'
import UserState from '../../store/UserAtom'
import {
  CardsContent,
  FlexWrapper,
} from './styles'

function GoiasTecClass() {
  const user = useRecoilValue(UserState)

  return (
    <>
      <Header />
      <CardsContent>
        <Container>
          <Title textcolor="#51A34F">Aulas</Title>
          <FlexWrapper>
            <GradeCard
              theme={themes.fundamental_dois}
              title="Fundamental - Anos Finais"
              links={[
                {
                  externo: false,
                  label: '8º Ano - Goiás Tec',
                  link: '/conteudos/goias_tec/291/?turma=8º Ano Goiás Tec&title=Fundamental - Anos Finais',
                },
                {
                  externo: false,
                  label: '9º Ano - Goiás Tec',
                  link: '/conteudos/goias_tec/292/?turma=9º Ano Goiás Tec&title=Fundamental - Anos Finais',
                },
              ]}
            />
            <GradeCard
              theme={themes.ensino_medio}
              title="Ensino Médio"
              links={[
                {
                  externo: false,
                  label: '1ª Série - Goiás Tec',
                  link: 'conteudos/goias_tec/191/?turma=1ª Série&title=Ensino Médio - Goiás Tec',
                },
                {
                  externo: false,
                  label: '2ª Série - Goiás Tec',
                  link: '/conteudos/goias_tec/192/?turma=2ª Série&title=Ensino Médio - Goiás Tec',
                },
                {
                  externo: false,
                  label: '3ª Série - Goiás Tec',
                  link: '/conteudos/goias_tec/193/?turma=3ª Série&title=Ensino Médio - Goiás Tec',
                }
              ]}
            />
          </FlexWrapper>
        </Container>
      </CardsContent>
      <Footer />
    </>
  )
}

export default GoiasTecClass
